export default __webpack_public_path__ + "static/affiliate-program-Software-1@mob-5b43093ccae975ea108999be6ddf75e0.webp";